module.exports = __webpack_public_path__ + "112f57e3183e6277cfb7a257f5c82bb2.MP3";